const options = {
    EM: [
        {
            label: 'Extract Maintenance',
            value: 'ExtractMaintenance',
            SelectionDisabled: true,
            children: [
                {
                    label: 'Template Details',
                    value: 'TemplateDetails'
                },
                {
                    label: 'Fields',
                    value: 'Fields'
                },
            ]
        }
    ],
};

export default options;
